export const APP_NAME = 'M365 Management App';

/** Creates the meta tag if missing, otherwise updates its content in place. */
export const upsertMetaTag = (selector: string, attributeName: string, attributeValue: string, content: string): void => {
  let meta = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attributeName, attributeValue);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
};
